import { personURL } from '../common.urls';
import ImmutableModel from '../immutable.model';

// These map to backend's JobTitle Type values.

const DENTIST_TITLE = 'Dentist';
const HYGIENIST_TITLE = 'DentalHygienist';
const SPECIAL_DENTIST_TITLE = 'SpecialDentist';
const SPECIAL_DOCTOR_TITLE = 'SpecialDoctor';
const DENTAL_TECHNICIAN_TITLE = 'DentalTechnician';
const SPECIAL_DENTAL_TECHNICIAN_TTILE = 'SpecialDentalTechnician';

// Person gender options
const GENDER_MALE = 'M';
const GENDER_FEMALE = 'F';

/**
 * A person retrieved from the backend.
 */
class Person extends ImmutableModel {
  /**
   * @param {Number} id
   * @param {String} first_name
   * @param {String} last_name
   * @param {String} title
   * @param {String} image
   * @param {Number} order_number
   * @param {Boolean} internet_active
   * @param {String} gender
   * @param {String} url
   * @param {Array.<Location>} locations
   * @param {Array.<String>} spoken_languages
   * @param {String} description
   * @param {Array.<Number>} service_categories
   * @param {Array.<Number>} service_groups
   * @param {Array.<String>} specializations
   * @param {Array.<Number>} services
   * @param {Array.<Number>} other_services
   * @param {?String} job_title
   * @param {?Boolean} serves_service_voucher_patients
   * @param {?Array.<Number>} service_voucher_locations
   */
  constructor(
    id,
    first_name,
    last_name,
    title,
    image,
    order_number,
    internet_active,
    gender,
    url,
    locations=null,
    spoken_languages=null,
    description=null,
    service_categories=null,
    service_groups=null,
    specializations=null,
    services=null,
    other_services=null,
    job_title=null,
    serves_service_voucher_patients=false,
    service_voucher_locations=null,
  ) {
    super();

    this.id = id;
    this.first_name = first_name;
    this.last_name = last_name;
    this.title = title;
    this.image = image;
    this.order_number = order_number;
    this.internet_active = internet_active;
    this.gender = gender;
    this.url = url || personURL(this);
    this.locations = locations;
    this.spoken_languages = spoken_languages;
    this.description = description;
    this.service_categories = service_categories;
    this.service_groups = service_groups;
    this.specializations = specializations;
    this.services = services;
    this.job_title = job_title;
    this.serves_service_voucher_patients = serves_service_voucher_patients;
    this.service_voucher_locations = service_voucher_locations;

    if (this.services != null && other_services != null) {
      // Main services must be removed from others to prevent possible duplicates.
      this.other_services = other_services.filter(id => !this.services.includes(id));
      this.all_services = this.services.concat(this.other_services);
    }
    else {
      this.other_services = other_services;
      this.all_services = this.other_services;
    }

    this.personImageStyle = null;
    if (this.image == null) {
      if (this.gender === GENDER_MALE) {
        this.personImageStyle = 'person-image-placeholder-male';
      }
      else if (this.gender === GENDER_FEMALE) {
        this.personImageStyle = 'person-image-placeholder-female';
      }
      else {
        this.personImageStyle = 'person-image-placeholder-unspecified';
      }
    }
  }

  /**
   * Is this a minimal representation? Minimal representations only have the most basic data retrieved from the backend.
   * @return {boolean}
   */
  get minimal() {
    return this.locations == null;
  }

  copy() {
    return new Person(
      this.id,
      this.first_name,
      this.last_name,
      this.title,
      this.image,
      this.order_number,
      this.internet_active,
      this.gender,
      this.url,
      this.locations,
      this.spoken_languages,
      this.description,
      this.service_categories,
      this.service_groups,
      this.specializations,
      this.services,
      this.other_services,
      this.job_title,
      this.serves_service_voucher_patients,
      this.service_voucher_locations,
    );
  }

  fullName() {
    return `${this.first_name} ${this.last_name}`;
  }
}

export {
  DENTIST_TITLE,
  HYGIENIST_TITLE,
  SPECIAL_DENTIST_TITLE,
  SPECIAL_DOCTOR_TITLE,
  DENTAL_TECHNICIAN_TITLE,
  SPECIAL_DENTAL_TECHNICIAN_TTILE
};
export default Person;
